module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学生请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('span', [_vm._v("请假类型：请单节课")])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    staticStyle: {
      "height": "50px",
      "width": "400px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._v("请假课程：" + _vm._s(_vm.leaveParam.beginTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.leaveParam.title))])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115382dd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson/UserOneLeaveModal.vue
// module id = 1643
// module chunks = 8